import MemberFilter from './MemberFilter.component';

export default MemberFilter;
